module.exports = __webpack_public_path__ + "img/2-9.b5c6f24a.png";